import advice from 'src/assets/Buy_Policy_Images/Advice.svg'
import assistance from 'src/assets/Buy_Policy_Images/Assistance.svg'
import bonusBenefits from 'src/assets/Buy_Policy_Images/BonusBenefits.svg'
import convenience from 'src/assets/Buy_Policy_Images/Convenience.svg'
import coverageOptions from 'src/assets/Buy_Policy_Images/CoverageOptions.svg'
import customization from 'src/assets/Buy_Policy_Images/Customization.svg'
import termProtection from 'src/assets/Buy_Policy_Images/TermProtection.svg'
import trust from 'src/assets/Buy_Policy_Images/Trust.svg'
import { Box } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import { FEATURE_ACTIONS } from 'src/utils/constants/BuyPolicyMotor'

const imageMap = {
  advice: advice,
  coverage: coverageOptions,
  customization: customization,
  assistance: assistance,
  bonus: bonusBenefits,
  convenience: convenience,
  longTerm: termProtection,
  trust: trust,
}

const Features = () => {
  const classes = useStyles()

  const getImage = (image) => {
    return imageMap[image] || undefined
  }

  return (
    <>
      <Box className={classes.componentBackground}>
        <Box className={classes.componentElement}>
          <Box className={classes.overallContainer}>
            <Box className={classes.headingContainer}>
              Key features of car insurance with Trovity
            </Box>
            <Box className={classes.wrapContainer}>
              {FEATURE_ACTIONS?.map((feature) => {
                return (
                  <Box className={classes.wrapAction} key={feature?.id}>
                    <Box className={classes.imageContainer}>
                      <img
                        src={getImage(feature?.image)}
                        alt='featureImage'
                        className={classes.imgSize}
                      />
                    </Box>
                    <Box className={classes.wrapContent}>
                      {feature?.heading}
                    </Box>
                    <Box className={classes.subContent}>{feature?.content}</Box>
                  </Box>
                )
              })}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
export default Features
const useStyles = makeStyles({
  overallContainer: {
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    paddingBottom: '10px',
  },
  headingContainer: {
    color: '#B92250',
    fontSize: '26px',
    fontFamily: 'Roboto',
    fontWeight: '400',
    paddingTop: '30px',
  },
  wrapContent: {
    color: '#2C2C2C',
    fontSize: '16px',
    fontFamily: 'Roboto',
    fontWeight: '600',
    textAlign: 'center',
  },
  subContent: {
    color: '#2C2C2C',
    fontSize: '13px',
    fontFamily: 'Roboto',
    fontWeight: '400',
    textAlign: 'center',
  },
  wrapAction: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background:
      'linear-gradient(180deg, #ECECEC 0%, rgba(255, 255, 255, 0) 60%)',
    gap: '12px',
    padding: '2% 2% 2% 2%',
    width: '19%',
    borderRadius: '10px',
    '@media (max-width:550px)': {
      width: '80%',
    },
  },
  wrapContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: 50,
    '@media (max-width:550px)': {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 10,
      gap: 20,
    },
  },
  imageContainer: {
    padding: '20px 20px 10px 20px',
  },
  imgSize: {
    width: '25px',
  },
  componentElement: {
    maxWidth: '1240px !important',
    width: '100%',
  },
  componentBackground: {
    background: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})
